import { WidgetType } from '@otw/models'

/** Stock-position cards that need the full unsold inventory list. Live on the Inventory tab. */
export const INVENTORY_DETAIL_WIDGET_IDS: WidgetType[] = [
  WidgetType.OUTSTANDING_OWED_CARD_1,
  WidgetType.OUTSTANDING_OWED_CARD_2,
  WidgetType.CHECKBOOK_AMOUNT,
  WidgetType.VEHICLES_OWNED,
  WidgetType.VEHICLES_OWNED_TOTAL_VALUE,
  WidgetType.VEHICLES_FUNDED,
  WidgetType.VEHICLES_FUNDED_TOTAL_VALUE,
  WidgetType.VEHICLES_FUNDED_NOT_PAID_COUNTS,
  WidgetType.VEHICLES_FUNDED_NOT_PAID_VALUES,
  WidgetType.VEHICLES_PENDING_SALE,
  WidgetType.PENDING_RETURNING_CAPITAL,
  WidgetType.PENDING_EXPECTED_REPAIR_COSTS,
  WidgetType.UNPAID_REPAIR_COSTS,
]

const INVENTORY_DETAIL_WIDGET_SET = new Set<string>(INVENTORY_DETAIL_WIDGET_IDS)

export const isInventoryDetailWidget = (widgetId: string): boolean =>
  INVENTORY_DETAIL_WIDGET_SET.has(widgetId)

export const hasInventoryDetailWidgets = (assignedWidgets?: string[]): boolean => {
  if (!assignedWidgets || assignedWidgets.length === 0) return false
  return assignedWidgets.some(isInventoryDetailWidget)
}
